import { Outlet } from "react-router-dom";

import BackofficeNiceModalProvider from "components/context/BackofficeNiceModalProvider";
import { ConstantBackofficeProvider } from "components/context/ConstantProvider";
import Layout from "components/ui/molecules/Layout";
import backofficeConfig from "models/backoffice/backofficeConfig";
import CustomProvider from "components/context/CustomProvider";
import modelExtraData from "models/backoffice/modelExtraData";
import useDidValueChange from "components/hooks/useDidValueChanged";

const BackofficeLayout = () => {
  useDidValueChange(modelExtraData, "modelExtraData");

  return (
    <ConstantBackofficeProvider>
      <CustomProvider modelExtraData={modelExtraData}>
        <BackofficeNiceModalProvider>
          <Layout container config={backofficeConfig} app="ringback">
            <Outlet />
          </Layout>
        </BackofficeNiceModalProvider>
      </CustomProvider>
    </ConstantBackofficeProvider>
  );
};

export default BackofficeLayout;
